import { UserCheckAuthorization_AuthErrorCode } from '../../clients/client-UserGroup';

export const isAuthErrorCodeKeyGuard = (key: string | number | undefined): key is AuthErrorCodeKey => {
  return key !== undefined;
};

export const AuthErrorCode = {
  ...UserCheckAuthorization_AuthErrorCode,
  ClockSkew: 1000,
  OtherError: 1001,
} as const;

export type AuthErrorCodeKey = keyof typeof AuthErrorCode;

export type AuthErrorCodeValue = typeof AuthErrorCode[AuthErrorCodeKey];
